// Flatten every category's selected ACMG criteria into a single list.
export default function collectEvaluations(categoryValuesObj) {
  return Object.values(categoryValuesObj).flatMap(category => {
    const evalValue = category?.eval;
    if (!evalValue || evalValue.length === 0) return [];
    return Array.isArray(evalValue) ? evalValue : [evalValue];
  });
}
